<template>
  <div
    :class="[
      `m-table`,
      {
        'm-table--clickable': rowClick,
      },
    ]"
  >
    <table
      class="m-table__table"
    >
      <thead
        class="m-table__head small"
      >
        <tr>
          <td
            v-for="(column, index) in columns"
            :key="index"

            :class="getCellClass({
              type: `heading`,
              column,
              index,
            })"

            v-html="!column.hidden ? column.heading : `\xa0`"
          />
        </tr>
      </thead>
      <tbody
        class="m-table__body small"
      >
        <tr
          v-for="(row, id) in rows"
          :key="id"

          :class="[
            `m-table__row`,
            `m-table__row--body`,
          ]"
          :title="getRowTitle(row)"
          @click="onRowClick($event, id, row)"
        >
          <td
            v-for="(column, index) in columns"
            :key="index"

            :class="getCellClass({
              type: `body`,
              column,
              index,
            })"
          >
            <component
              v-if="typeof(column.value) === `function` && (column.value(row) || {}).is"

              :is="column.value(row).is"

              v-bind="column.value(row).bind || {}"
            />
            <template v-else>{{ (typeof(column.value) === `function` ? column.value(row) : column.value) || `-` }}</template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// Services
import { arrayLoop, isArray } from 'services/array';

// Inline
import InlineImageIconsSpinner from 'images/icons/spinner.svg?inline';

// Export
export default {
  name: `module-table`,

  // Components
  components: {
    InlineImageIconsSpinner,
  },

  // Props
  props: {
    columns: {
      type: Array,
    },
    rows: {
      type: [
        Array,
        Object,
      ],
    },
    rowClick: {
      type: Boolean,
    },
    rowTitle: {
      type: Function,
    },
  },

  // Data
  computed: {
    rowsSet() {
      if (!isArray(this.rows)) return this.rows;

      const rows = {};
      arrayLoop(this.rows || [], (i, row) => rows[i] = row);
      return rows;
    },
  },

  // Methods
  methods: {
    getCellClass({ type, column, index }) {
      return [
        `m-table__cell`,
        `m-table__cell--${type}`,
        `m-table__cell--${index}`,
        column.align ? `m-table__cell--align-${column.align}` : ``,
      ];
    },
    onRowClick(e, id, row) {
      if (!this.rowClick) return false;

      this.$emit(`row-click`, id, row);
    },
    getRowTitle(row) {
      return typeof this.rowTitle === `function` ? this.rowTitle(row) : ``;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Table.vue?c71485cc